<template>
  <div class="ni-app-header-wrapper columns">
    <h3 class="column is-3">New Item Submission</h3>
  </div>
</template>

<script>
export default {
  name: "NewItemAppHeader"
};
</script>

<style scoped></style>
